<template>
  <a-modal width="800px" :visible="visible" :closable="false">
    <h5 class="mt-2 mb-3">
      {{ $t('inventory.goods_receipt.list_revised') }}
    </h5>
    <a-spin :spinning="isLoading" size="large" :tip="$t('inventory.goods_receipt.uploading')">
      <div>
        <a-table
          :columns="columns"
          :row-key="(record, index) => index"
          :data-source="revisedData"
          :loading="isLoading"
          :pagination="false"
          :scroll="{ y: 330 }"
        >
          <template slot="status" slot-scope="text">
            <a-tag v-if="text.includes('sku_not_found')" color="red">
              {{ $t('inventory.goods_receipt.sku_not_found') }}
            </a-tag>
            <a-tag v-if="text.includes('uom_not_valid')" color="orange">
              {{ $t('inventory.goods_receipt.uom_not_valid') }}
            </a-tag>
            <a-tag v-if="text.includes('data_not_valid')" color="purple">
              {{ $t('inventory.goods_receipt.data_not_valid') }}
            </a-tag>
          </template>
        </a-table>
      </div>
    </a-spin>
    <template #footer>
      <a-button key="back" class="mr-2" @click="typeof back !== 'undefined' && back(), onClose()">
        {{ $t('inventory.goods_receipt.close_no_download') }}
      </a-button>
      <a-button type="primary" class="mr-2" @click.prevent="downloadTemplate">
        <a-icon type="download" />
        {{ $t('inventory.goods_receipt.close_download') }}
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import getQueryParam from '@/utils/getQueryParam'
import XLSX from 'xlsx';
import { columnsRevisedDataGR } from '@/data/columns'

export default {
  name: 'ModalFeedbackAfterImport',
  components: {
  },
  mixins: [getQueryParam],
  props: {
    revisedData: Array,
    visible: Boolean,
    back: Function,
    onClose: Function,
    isLoading: Boolean,
  },
  data() {
    return {}
  },
  computed: {
    columns() {
      return [
        {
          title: 'SKU',
          dataIndex: 'sku',
          key: 'sku',
          width: 250,
        },
        {
          title: this.$t('inventory.goods_receipt.qty'),
          dataIndex: 'qty',
          width: 100,
          key: 'qty',
        },
        {
          title: this.$t('inventory.goods_receipt.uom'),
          dataIndex: 'uom',
          width: 50,
          key: 'uom',
        },
        {
          title: this.$t('inventory.goods_receipt.note'),
          dataIndex: 'message',
          key: 'message',
          width: 150,
          scopedSlots: {
            customRender: 'message',
          },
        },
      ]
    },
  },
  methods: {
    downloadTemplate() {
      const flattenData = this.revisedData.map((obj) => ({
        sku: obj.sku,
        quantity: obj.quantity,
        uom: obj.uom,
      }))
      const rowData = [
        "SKU",
        "Quantity",
        "UOM",
      ]
      const worksheet = XLSX.utils.json_to_sheet(flattenData);
      const workbook = XLSX.utils.book_new()
      XLSX.utils.sheet_add_aoa(worksheet, [rowData], { origin: "A1" });
      XLSX.utils.book_append_sheet(workbook, worksheet, 'data')
      XLSX.writeFile(workbook,'file_revised_data_gr.xlsx')
      this.onClose()
    },
  },
}
</script>

<style lang="scss" module>
</style>